// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'tiny... Remove this comment to see the full error message
import tinymce from 'tinymce';
import * as Colors from 'HubStyleTokens/colors';
import { getIsPropertyOnlyToken, getTagUseFromCategory } from 'rich-text-lib/utils/properties';
import { compose } from 'rich-text-lib/utils/iterables';
import { PropertyCategories, UserPropertyOptions } from 'rich-text-lib/constants/properties';
import { getPathsMap, getPropertiesLabelsMap } from 'rich-text-lib/utils/buildProperties';

// @ts-expect-error tinymce-themes is not typed
import { getTrellisThemeSingleton } from 'tinymce-themes/utils/trellis';
import { parseHtml, replaceNodes, addPostProcessTransform, addPreProcessTransform } from './transformer';
import { i18nWithNameSpace } from './i18n';
import { getHublVariable } from './hubl';
import { insertAtInnerMostLeaf, getSingleInnerMostLeaf, replaceInnerMostLeaf } from './dom';
import { trackInteraction } from './usageTracking';
import { PERSONALIZATION_TOKEN_CASING } from '../constants/usageTracking';
import { getHsPersonalizeSettings } from '../utils';
import { unescapeEscapedSingleQuote } from './stringTransform';
const i18nKey = i18nWithNameSpace('TinymcePlugins.hspersonalize.propertyOnlyTokens');
const styles = new tinymce.html.Styles();
const getPlaceholderStyles = ({
  color,
  backgroundColor
}) => ({
  color: `${color} !important`,
  display: 'inline-block',
  padding: '4px 7px',
  'background-color': backgroundColor,
  'border-radius': '2px',
  'box-shadow': '0 0 1px 0 rgba(0, 0, 0, 0.3)',
  'vertical-align': 'middle',
  'user-select': 'text',
  'line-height': 1
});

/**
 *
 * @param {String} tagUse "theme" of token style
 * @returns {Object} color and background color for token
 */
const getTokenColorsFromTagUse = tagUse => {
  let color = '';
  let backgroundColor = '';
  switch (tagUse) {
    case 'sorbet':
      color = Colors.SORBET;
      backgroundColor = Colors.SORBET_LIGHT;
      break;
    case 'calypso':
      color = Colors.CALYPSO;
      backgroundColor = Colors.CALYPSO_LIGHT;
      break;
    case 'default':
      color = Colors.OBSIDIAN;
      backgroundColor = Colors.KOALA;
      break;
    case 'success':
    case 'oz':
      color = Colors.OZ;
      backgroundColor = Colors.OZ_LIGHT;
      break;
    case 'warning':
      color = Colors.MARIGOLD;
      backgroundColor = Colors.MARIGOLD_LIGHT;
      break;
    case 'thunderdome':
    default:
      color = Colors.THUNDERDOME;
      backgroundColor = Colors.THUNDERDOME_LIGHT;
  }
  return {
    color,
    backgroundColor
  };
};

/**
 *
 * @param {String} category token category
 * @returns {Object} color and background color for token
 */
const getTokenColorsFromCategory = compose(getTokenColorsFromTagUse, getTagUseFromCategory);

/**
 *
 * @param {String} category token category
 * @returns {String} icon code for custom font
 */
const getTokenIconFromCategory = (category = '') => {
  switch (category.toLowerCase()) {
    case PropertyCategories.CONTACT:
      return 'contacts';
    case PropertyCategories.COMPANY:
      return 'companies';
    case PropertyCategories.DEAL:
      return 'deals';
    case PropertyCategories.QUOTE:
    case PropertyCategories.LINE_ITEM:
      return 'salesQuote';
    case PropertyCategories.TICKET:
      return 'ticket';
    case PropertyCategories.INVOICE:
      return 'invoice';
    case PropertyCategories.CART:
      return 'cart';
    default:
      return 'hubDB';
  }
};

/**
 *
 * @param {String} hublVar token hubl string
 * @returns {Object} token propertites
 */
export const splitHublVar = hublVar => {
  const parts = hublVar.split('.');
  if (!parts.length) {
    return null;
  }
  if (parts.length === 1) {
    return {
      property: parts[0]
    };
  }
  return {
    category: parts[0],
    property: parts[1],
    subProperty: parts[2]
  };
};

/**
 *
 * @param {String} str maybe token hubl string
 * @returns {(Object|null)} token propertites
 */
export const getTokenProperties = str => {
  const hublVar = getHublVariable(str);
  if (!hublVar) {
    return null;
  }
  return splitHublVar(hublVar);
};

// Create an inner placeholder element which can be styled but not selected
/**
 *
 * @param {Boolean} placeholder if inner token node is for editor placeholder or content wrapper
 * @returns {Node} Inner token node
 */
const generateInnerToken = (placeholder = true) => {
  const innerToken = document.createElement('span');
  if (placeholder) {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'boolean' is not assignable to pa... Remove this comment to see the full error message
    innerToken.setAttribute('contenteditable', true);
    innerToken.style.pointerEvents = 'none';
  } else {
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'boolean' is not assignable to type 'string'.
    innerToken.dataset.hsMceToken = true;
  }
  return innerToken;
};

/**
 *
 * @param {Object} properties
 * @returns {String} Translated property label
 */
export const getPlaceholderLabel = (properties, personalizeConfig) => {
  const {
    category,
    property,
    subProperty
  } = properties;
  let labelPath;
  let label;
  const isPropertyOnlyToken = getIsPropertyOnlyToken(category, property);
  if (isPropertyOnlyToken) {
    labelPath = property;
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
    label = i18nKey(labelPath);
  } else if (category) {
    labelPath = `${category}.${property}`;
    const labelsMap = getPropertiesLabelsMap(personalizeConfig) || {};
    label = labelsMap[labelPath] || '';
    if (label && property === 'hubspot_owner_id') {
      const subPropertyOption = UserPropertyOptions.find(({
        value
      }) => value === subProperty);
      label = subPropertyOption ? `${label} > ${subPropertyOption.text}` : label;
    }
  } else {
    label = property;
  }
  return label;
};

/**
 *
 * @param {Node} placeholder
 * @returns {HTMLElement | null} Node tree of elements used to style token or null
 */
const getTokenInlineStyleNodes = placeholder => {
  const innerToken = placeholder.querySelector('[contenteditable=true]');
  const styledRoot = innerToken && innerToken.firstElementChild ? innerToken.firstElementChild.cloneNode(true) : null;
  if (!styledRoot) {
    return styledRoot;
  }
  styledRoot.dataset.hsTokenStyleRoot = 'true';
  const textNode = getSingleInnerMostLeaf(styledRoot);
  if (textNode && textNode.parentElement) {
    textNode.parentElement.removeChild(textNode);
  }
  return styledRoot;
};

/**
 *
 * @param {Node} placeholder
 * @param {Node} textTokenNode
 * @returns Node tree of elements used to style token or null
 */
export const generateInnerTokenWithTextNode = (placeholderNode, textTokenNode) => {
  const tokenInlineStyleNodes = getTokenInlineStyleNodes(placeholderNode);
  if (tokenInlineStyleNodes) {
    insertAtInnerMostLeaf(tokenInlineStyleNodes, textTokenNode);
  }
  return tokenInlineStyleNodes || textTokenNode;
};

/**
 *
 * @param {String} category token cateogry
 * @returns {Node} Noneditable node with appropriate token colors applied
 */
const generatePlaceholderNode = category => {
  const tokenColors = getTokenColorsFromCategory(category);
  const placeholderNode = document.createElement('span');
  const placeholderStyles = styles.serialize(getPlaceholderStyles(tokenColors));
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'boolean' is not assignable to pa... Remove this comment to see the full error message
  placeholderNode.setAttribute('contenteditable', false);
  placeholderNode.setAttribute('style', placeholderStyles);
  placeholderNode.className = 'mce-token mceNonEditable';
  // @ts-expect-error ts-migrate(2322) FIXME: Type 'boolean' is not assignable to type 'string'.
  placeholderNode.dataset.mcePlaceholder = true;
  return placeholderNode;
};

/**
 *
 * @param {Object} properties
 * @param {String} label
 * @param {Node} token
 */
const setTokenAttributes = (properties, label, token) => {
  const {
    category,
    property,
    subProperty,
    defaultValue
  } = properties;
  const tagUse = getTagUseFromCategory(category);
  const isPropertyOnlyToken = getIsPropertyOnlyToken(category, property);
  token.setAttribute('data-mce-hubspot-object', 'true');
  token.setAttribute('data-mce-property-category', isPropertyOnlyToken ? 'property-only' : category);
  token.setAttribute('data-mce-property-name', property);
  if (subProperty) {
    token.setAttribute('data-mce-subproperty', subProperty);
  }
  if (label) {
    token.setAttribute('data-mce-property-label', label);
  }
  if (defaultValue != null) {
    token.setAttribute('data-mce-property-default-value', defaultValue);
  }
  token.classList.add(tagUse);
};
export const isEditableToken = (editor, node) => {
  return editor.dom.is(node, 'span[data-mce-hubspot-object=true][data-mce-placeholder=true][data-mce-property-category!=post], img[data-mce-hubspot-object=true][data-mce-placeholder=true][data-mce-property-category!=post]');
};
export const isEditableRSSToken = (editor, element) => {
  const isRssToken = editor.dom.is(element, 'span[data-mce-hubspot-object=true][data-mce-placeholder=true][data-mce-property-category=post], img[data-mce-hubspot-object=true][data-mce-placeholder=true][data-mce-property-category=post]');
  const anchorNode = editor.dom.getParent(element, 'a', editor.getBody());
  const isRssLink = anchorNode && anchorNode.hasAttribute('data-mce-rss-link');
  return isRssToken || isRssLink;
};
export function tokenIsOnlyChild(editor, node) {
  if (isEditableToken(editor, node)) return true;
  const childNodes = [...node.childNodes];
  if (childNodes.length === 1) {
    return tokenIsOnlyChild(editor, childNodes[0]);
  }
  return false;
}
export const getPropertyValues = element => {
  const defaultValueAttr = element.dataset.mcePropertyDefaultValue;
  const defaultValue = defaultValueAttr && tinymce.html.Entities.decode(defaultValueAttr);
  return {
    category: element.dataset.mcePropertyCategory,
    property: element.dataset.mcePropertyName,
    fallback: defaultValueAttr && defaultValue !== '' ? unescapeEscapedSingleQuote(defaultValue) : defaultValue,
    subCategory: element.dataset.mceSubproperty
  };
};
export const getDataTokenValues = (dataTokenConfig, element) => {
  const defaultValueAttr = element.dataset.mcePropertyDefaultValue;
  const defaultValue = defaultValueAttr && tinymce.html.Entities.decode(defaultValueAttr);
  const pathsMap = getPathsMap(dataTokenConfig) || {};
  const path = element.dataset.mceTokenPath || '';
  const pathData = pathsMap[path] || {};
  return {
    category: pathData.category,
    field: pathData.field,
    fallback: defaultValueAttr && defaultValue !== '' ? unescapeEscapedSingleQuote(defaultValue) : defaultValue,
    hasDataSensitivity: pathData.hasDataSensitivity
  };
};
const UPSCALING_FACTOR = 4;
const align = value => Math.floor(value / UPSCALING_FACTOR) * UPSCALING_FACTOR;
export const renderTokenBase = (text, category, setImgAttrFromProps, hasDataSensitivity) => {
  const theme = getTrellisThemeSingleton();
  const tokenHeight = 26 * UPSCALING_FACTOR;
  const textBaselineBuffer = 7 * UPSCALING_FACTOR;
  const tokenWidthBuffer = 16 * UPSCALING_FACTOR;
  const spaceAfterIcon = 8 * UPSCALING_FACTOR;
  const textSize = 16 * UPSCALING_FACTOR;
  const font = `${textSize}px ${theme.typography['body-100'].fontFamily}`;
  const iconFont = `${textSize}px spacesword`;
  const tokenColors = {
    color: theme.color['icon-core-default'],
    backgroundColor: hasDataSensitivity ? theme.color['fill-alert-subtle'] : theme.color['fill-surface-default'],
    borderColor: hasDataSensitivity ? theme.color['border-alert-default'] : theme.color['border-core-default']
  };
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  const tokenIcon = getTokenIconFromCategory(category);

  // This is a temp fix because of a bug in FF that cannot set
  // font on a canvas 2d context within an iframe that is hidden
  // see: https://issues.hubspotcentral.com/browse/COSEMAIL-10478
  try {
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    context.font = font;
  } catch (error) {
    console.error('Could not set font on context', error);
  }

  // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
  const textWidth = context.measureText(text).width;
  try {
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    context.font = iconFont;
  } catch (error) {
    console.error('Could not set font on context', error);
  }
  // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
  const iconWidth = context.measureText(tokenIcon).width;

  // space breakdown of token image along width
  // | 1/2 token height buffer | icon width | 8px | text width | 1/2 token height buffer |
  const totalWidth = iconWidth + textWidth + tokenWidthBuffer + spaceAfterIcon;
  canvas.setAttribute('width', `${align(totalWidth)}px`);
  canvas.setAttribute('height', `${align(tokenHeight)}px`);

  // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
  context.fillStyle = tokenColors.color;
  // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
  context.textAlign = 'left';
  try {
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    context.font = iconFont;
  } catch (error) {
    console.error('Could not set font on context', error);
  }
  let x = tokenWidthBuffer / 2;
  let y = tokenHeight - textBaselineBuffer;
  // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
  context.fillText(tokenIcon, align(x), align(y));

  // This is a temp fix because of a bug in FF that cannot set
  // font on a canvas 2d context within an iframe that is hidden
  // see: https://issues.hubspotcentral.com/browse/COSEMAIL-10478
  try {
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    context.font = font;
  } catch (error) {
    console.error('Could not set font on context', error);
  }
  x = totalWidth - textWidth - tokenWidthBuffer / 2;
  y = tokenHeight - textBaselineBuffer;
  // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
  context.fillText(text, align(x), align(y));
  const image = document.createElement('img');
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'boolean' is not assignable to pa... Remove this comment to see the full error message
  image.setAttribute('data-mce-placeholder', true);
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'boolean' is not assignable to pa... Remove this comment to see the full error message
  image.setAttribute('data-mce-resize', false);
  image.classList.add('mce-token');
  image.setAttribute('style', `width: ${Math.floor(
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
  parseInt(canvas.getAttribute('width'), 10) / UPSCALING_FACTOR + 2)}px !important; height: ${Math.floor(
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
  parseInt(canvas.getAttribute('height'), 10) / UPSCALING_FACTOR + 2)}px !important; background: ${tokenColors.backgroundColor}; border: 1px solid ${tokenColors.borderColor}; border-radius: 2px; vertical-align: middle; box-sizing: border-box;`);
  image.setAttribute('src', canvas.toDataURL());
  setImgAttrFromProps(image);
  return image;
};

// Helper to convert customObjectPrefixes to the corresponding FQN
const verifyCategory = (prefixes, category) => {
  if (!prefixes || typeof prefixes !== 'object') return category;
  let validCategory = category;
  Object.keys(prefixes).forEach(key => {
    const value = prefixes[key];
    if (value === category) {
      validCategory = key;
    }
  });
  return validCategory;
};

// Check for an improperly cased (lowercased) `category` compared
// to the appropriate case-sensitive FQN, then track this in amplitude.
// Part of https://git.hubteam.com/HubSpot/Critsit/issues/2576 postmortem.
const checkForImproperlyCasedFQNs = (editor, supportedCrmObjectFQNs, category) => {
  const properlyCasedFQN = supportedCrmObjectFQNs.find(fqn => category === fqn.toLowerCase() && category !== fqn);
  if (properlyCasedFQN) {
    trackInteraction(editor, 'tinymcePersonalize', PERSONALIZATION_TOKEN_CASING, {
      category,
      fqn: properlyCasedFQN
    });
  }
  return !!properlyCasedFQN;
};
const replaceHubLWithToken = (editor, supportedCrmObjectFQNs, prefixes, textContent, tokenPatternArray, renderFunction) => {
  let newTextContent = textContent;
  tokenPatternArray.forEach(({
    TOKEN_PATTERN,
    USES_DEFAULT,
    PROPERTY_ONLY
  }) => {
    if (PROPERTY_ONLY) {
      newTextContent = newTextContent.replace(TOKEN_PATTERN, (__fullToken, category) => {
        const validCategory = verifyCategory(prefixes, category);
        return renderFunction({
          property: validCategory
        });
      });
    } else if (USES_DEFAULT) {
      newTextContent = newTextContent.replace(TOKEN_PATTERN, (fullToken, category, property, subProperty, defaultValue, filter) => {
        const validCategory = verifyCategory(prefixes, category);
        const isImproperlyCasedFQN = checkForImproperlyCasedFQNs(editor, supportedCrmObjectFQNs, validCategory);
        if (isImproperlyCasedFQN) return fullToken;
        return renderFunction(Object.assign({
          property,
          category: validCategory,
          subProperty,
          defaultValue
        }, typeof filter === 'string' && {
          filter
        }));
      });
    } else {
      newTextContent = newTextContent.replace(TOKEN_PATTERN, (fullToken, category, property, subProperty, filter) => {
        const validCategory = verifyCategory(prefixes, category);
        const isImproperlyCasedFQN = checkForImproperlyCasedFQNs(editor, supportedCrmObjectFQNs, validCategory);
        if (isImproperlyCasedFQN) return fullToken;
        return renderFunction(Object.assign({
          property,
          category: validCategory,
          subProperty
        }, typeof filter === 'string' && {
          filter
        }));
      });
    }
  });
  return newTextContent;
};
const encode = tinymce.html.Entities.getEncodeFunc('named');
export const addTokenTransforms = (editor, supportedCrmObjectFQNs, prefixes, tokenPatternArray, renderPlaceHolder, replacePlaceholderWithHubl) => {
  const replaceHubLWithPlaceholder = tokenNode => {
    const newTextContent = replaceHubLWithToken(editor, supportedCrmObjectFQNs, prefixes, encode(tokenNode.textContent), tokenPatternArray, renderPlaceHolder);
    const doc = parseHtml(`<div>${newTextContent}</div>`);
    if (doc.body && doc.body.firstChild) {
      return doc.body.firstChild.childNodes;
    }
    return tokenNode;
  };
  const replaceStyledTokenWithPlaceholder = styledTokenNode => {
    const renderFunction = properties => {
      const personalizeConfig = getHsPersonalizeSettings(editor);
      // Get Label Node
      const placeholderLabel = getPlaceholderLabel(properties, personalizeConfig);
      const labelNode = document.createTextNode(placeholderLabel);

      // // Get Style Nodes
      const styledTokenNodeClone = styledTokenNode.cloneNode(true);
      styledTokenNodeClone.removeAttribute('data-hs-token-style-root');

      // Build placeholder node
      const placeholderNode = generatePlaceholderNode(properties.category);

      // Build inner node?
      const innerToken = generateInnerToken();

      // Placeholder Attributes
      setTokenAttributes(properties, placeholderLabel, placeholderNode);

      // Swap hubl with Label
      replaceInnerMostLeaf(styledTokenNodeClone, labelNode);

      // Build Placeholder tree
      innerToken.appendChild(styledTokenNodeClone);
      placeholderNode.appendChild(innerToken);
      return placeholderNode.outerHTML;
    };
    const newTextContent = replaceHubLWithToken(editor, supportedCrmObjectFQNs, prefixes, styledTokenNode.textContent || '', tokenPatternArray, renderFunction);
    const doc = parseHtml(newTextContent);
    return doc.body.childNodes;
  };

  // transform "new" tokens
  addPreProcessTransform(editor, dom => {
    const styledTokens = dom.querySelectorAll('[data-hs-token-style-root=true]');
    replaceNodes(styledTokens, replaceStyledTokenWithPlaceholder);
  });
  addPreProcessTransform(editor, dom => {
    const textNodeIterator = dom.createNodeIterator(dom.body, NodeFilter.SHOW_TEXT, node => {
      tokenPatternArray.forEach(({
        TOKEN_PATTERN
      }) => {
        TOKEN_PATTERN.lastIndex = 0;
      });
      const nodeTextContent = node.textContent;
      if (tokenPatternArray.some(({
        TOKEN_PATTERN
      }) => {
        return TOKEN_PATTERN.test(nodeTextContent || '');
      })) {
        return NodeFilter.FILTER_ACCEPT;
      }
      return NodeFilter.FILTER_REJECT;
    });
    const textNodes = [];
    let currentNode = textNodeIterator.nextNode();
    while (currentNode) {
      textNodes.push(currentNode);
      currentNode = textNodeIterator.nextNode();
    }
    replaceNodes(textNodes, replaceHubLWithPlaceholder);
  });
  addPostProcessTransform(editor, dom => {
    const tokenPlaceholderNodes = dom.querySelectorAll('[data-mce-property-name]:not([data-mce-rss-link])');
    replaceNodes(tokenPlaceholderNodes, replacePlaceholderWithHubl);
  });
};